module.exports = __webpack_public_path__ + "assets/icons/ic_remove_red_eye_24px.svg";